import { bffServiceInstance } from "@/plugins/api_service/services";

const prefix = "/management/corporates";

export default {
  search: (queryForm, facility_code, login_organization) =>
    bffServiceInstance.get(`${prefix}`, {
      ...queryForm,
      facility_code: facility_code,
      login_organization: login_organization,
    }),
  filterSearching: ({ page, default_search, advanced_search }) =>
    bffServiceInstance.post(
      `${prefix}/search`,
      {},
      { page, default_search, advanced_search }
    ),
  getCorporateCmsSearch: (facilityCode) =>
    bffServiceInstance.get(
      `/management/member-cms/get-cms-search-for-corporate`,
      {
        facility_code: facilityCode,
      }
    ),
  getCmsDetailForCorporate: (facilityCode, screen) => {
    if (!["create", "edit", "detail"].includes(screen)) {
      throw new Error("Parameter screen is not valid!");
    }
    return bffServiceInstance.get(
      `/management/member-cms/get-cms-detail-for-corporate`,
      {
        facility_code: facilityCode,
        screen: screen,
      }
    );
  },
  create: () => bffServiceInstance.get(`${prefix}/create`, {}),
  store: (memberForm) => {
    return bffServiceInstance.post(`${prefix}`, {}, memberForm);
  },

  show: (id) => bffServiceInstance.get(`${prefix}/${id}`),
  update: (id, body) => bffServiceInstance.put(`${prefix}/${id}`, {}, body),
  remove: (id) => bffServiceInstance.delete(`${prefix}/${id}`),
  detail: (id) => bffServiceInstance.get(`${prefix}/detail/${id}`),
};
